"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abtests = exports.TestCases = exports.COOKIE_NAME_SEP = exports.COOKIE_PREFIX = void 0;
exports.COOKIE_PREFIX = 'gp_ab';
exports.COOKIE_NAME_SEP = '__';
var TestCases;
(function (TestCases) {
    TestCases["A"] = "A";
    TestCases["B"] = "B";
    TestCases["C"] = "C";
    TestCases["D"] = "D";
    TestCases["E"] = "E";
    TestCases["F"] = "F";
    TestCases["G"] = "G";
    TestCases["H"] = "H";
    TestCases["I"] = "I";
    TestCases["J"] = "J";
    TestCases["K"] = "K";
    TestCases["L"] = "L";
    TestCases["M"] = "M";
    TestCases["N"] = "N";
    TestCases["O"] = "O";
    TestCases["P"] = "P";
    TestCases["Q"] = "Q";
    TestCases["R"] = "R";
    TestCases["S"] = "S";
    TestCases["T"] = "T";
    TestCases["U"] = "U";
    TestCases["V"] = "V";
    TestCases["W"] = "W";
    TestCases["X"] = "X";
    TestCases["Y"] = "Y";
    TestCases["Z"] = "Z";
    TestCases["absent"] = "absent";
})(TestCases = exports.TestCases || (exports.TestCases = {}));
const abtests = (cookies) => {
    return Object
        .keys(cookies)
        .filter((cookieName) => cookieName.indexOf(exports.COOKIE_PREFIX) > -1)
        .map((cookieName) => {
        const [, testName, testId] = cookieName.split(exports.COOKIE_NAME_SEP);
        return {
            cookieName,
            testName,
            testValue: cookies[cookieName],
            testId: Number(testId) || null
        };
    })
        .filter((test) => Object.values(TestCases).includes(test.testValue));
};
exports.abtests = abtests;
exports.default = exports.abtests;
//# sourceMappingURL=abtests.js.map